import * as React from 'react';
import { IgcRadioGroupComponent as Component } from 'igniteui-webcomponents';
import type { IgcRadioComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * The igc-radio-group component unifies one or more igc-radio buttons.
 * @slot  - Default slot
 * @class
 */
export const IgrRadioGroup = /* @__PURE__ */ createComponent({
  tagName: 'igc-radio-group',
  displayName: 'IgrRadioGroup',
  elementClass: Component,
  react: React,
  events: {
    onChange: 'igcChange' as EventName<IgcRadioComponentEventMap['igcChange']>,
  },
});

export type IgrRadioGroup = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrRadioGroupModule = Component;
